export const FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL = 'FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL';
export const FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE';
